import React from 'react';
import Checklist from '../assets/images/Checklist.svg';

export default () => {
  return <img src={Checklist} alt="" />;
};
